import { Container, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { cloneDeep } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import { reloadFacilities, updateFacility } from '../../../actions/facilities/facilities.actions'
import AreaDialog from '../../../components/Dialogs/AreaDialog'
import DeleteConfirmation from '../../../components/Dialogs/DeleteConfirmation'
import KennelBlockDialog from '../../../components/Dialogs/KennelBlockDialogSetup'
import KennelTypeDialog from '../../../components/Dialogs/KennelTypeDialog'
import PlaygroupTypeDialog from '../../../components/Dialogs/PlaygroupTypeDialog'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import { AreasTable } from '../../../components/Tables/AreasTable'
import { KennelBlocksTable } from '../../../components/Tables/KennelBlocksTable'
import { KennelTypesTable } from '../../../components/Tables/KennelTypesTable'
import { PlaygroupTypesTable } from '../../../components/Tables/PlaygroupTypesTable'
import { TIME_ZONE_ABBREVIATIONS } from '../../../utils'

const cutoffs = [
	{ name: 'The Day Of', number: 0 },
	{ name: 'One Day Before', number: 1 },
	{ name: 'Two Days Before', number: 2 }
]
const useStyles = makeStyles((theme) => ({
	root: {
		// flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '25px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important'
	},
	grid: {},
	gridDouble: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'flex-start'
	},
	fieldWrapper: {
		// '& .MuiTextField-root': { width: '100%', minWidth: '100%' }
	},
	header: {
		fontSize: 12,
		fontWeight: '800',
		letterSpacing: 0.75,
		marginTop: 24,
		marginBottom: 8
	},
	header2: {
		fontSize: 12,
		fontWeight: '800',
		letterSpacing: 0.75,
		marginTop: 24,
		marginBottom: 8
	},
	purple: {
		backgroundColor: '#F0EDFB',
		width: '400px',
		padding: 12,
		paddingTop: 16,
		paddingBottom: 16,
		borderRadius: 10
	},
	purpleText: {
		fontSize: 14,
		lineHeight: '21px',
		color: '#270050',
		padding: 0,
		margin: 0
	}
}))

const PetCareSetup = () => {
	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()
	const history = useHistory()
	const location = useLocation()

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)
	const markets = useSelector((state) => state.specific.markets.markets)
	const loading = useSelector((state) => state.specific.facilities.loading)
	const [current, setCurrent] = useState(null)
	const [isSaveShown, setIsSaveShown] = useState(false)
	const [startTime, setStartTime] = useState(new Date())
	const [bookingCutoffTime, setBookingCutoffTime] = useState(new Date())
	const [noShowTime, setNoShowTime] = useState(new Date())
	const [type, setType] = useState('daycare')
	const [timeZone, setTimeZone] = useState('')
	const [playgroupTypeDialog, setPlaygroupTypeDialog] = useState(false)
	const [playgroupType, selectPlaygroupType] = useState({})
	const [kennelBlockDialog, setKennelBlockDialog] = useState(false)
	const [kennelBlock, selectKennelBlock] = useState({})
	const [kennelType, selectKennelType] = useState({})
	const [kennelTypeDialog, setKennelTypeDialog] = useState(false)
	const [area, selectArea] = useState({})
	const [areaDialog, setAreaDialog] = useState(false)
	const [isDeleteOpen, setIsDeleteOpen] = useState(false)
	const [deleteText, setDeleteText] = useState('')

	useEffect(() => {
		if (location?.pathname?.includes('boarding')) setType('boarding')
		if (location?.pathname?.includes('compatibility')) setType('compatibility')
	}, [location])

	useEffect(() => {
		dispatch(reloadFacilities(false))
	}, [])

	useEffect(() => {
		if (params.facilityId && selectedFacility) {
			setCurrent(cloneDeep(selectedFacility))
		}
	}, [params.facilityId, selectedFacility])

	useEffect(() => {
		if (markets && markets.length && selectedFacility) {
			let market = markets.find((m) => m._id === selectedFacility.market_id)
			if (market?.time_zone) {
				let tz = TIME_ZONE_ABBREVIATIONS[market.time_zone]
				if (tz) setTimeZone(tz)
			}
		}
	}, [selectedFacility, markets])

	const setUpDelete = (type) => {
		setDeleteText(type)
		setIsDeleteOpen(true)
	}

	const onConfirmDelete = () => {
		if (deleteText === 'kennel block') return deleteKennelBlock()
		if (deleteText === 'playgroup type') return deletePlaygroupType()
		if (deleteText === 'area') return deleteArea()
		if (deleteText === 'kennel type') return deleteKennelType()

		alert('didnt work')
	}

	const deleteKennelBlock = () => {
		try {
			const obj = {
				kennel_blocks: current.kennel_blocks.map((kb) => {
					return {
						...kb,
						delete: kb._id === kennelBlock._id ? true : false
					}
				}),
				kennels: current.kennels.map((k) => ({
					...k,
					kennel_block_id: k.kennel_block_id === kennelBlock._id ? '' : k.kennel_block_id
				}))
			}
			setIsDeleteOpen(false)
			saveSelectedFacility(obj)
			setKennelBlockDialog(false)
			selectKennelBlock({})
			setCurrent({ ...current, ...obj })
		} catch (e) {
			console.log('big e..', e)
		}
	}

	const deletePlaygroupType = () => {
		try {
			const obj = {
				playgroup_types: current.playgroup_types.map((k) => {
					return {
						...k,
						delete: k._id === playgroupType._id ? true : false
					}
				}),
				playgroups: current.playgroups.map((p) => ({
					...p,
					playgroup_type_id: p.playgroup_type_id === playgroupType._id ? '' : p.playgroup_type_id
				}))
			}
			setIsDeleteOpen(false)
			saveSelectedFacility(obj)
			setPlaygroupTypeDialog(false)
			selectPlaygroupType({})
			setCurrent({ ...current, ...obj })
		} catch (e) {
			console.log('big e..', e)
		}
	}

	const deleteArea = () => {
		try {
			const obj = {
				areas: current.areas.map((k) => {
					return {
						...k,
						delete: k._id === area._id ? true : false
					}
				}),
				kennels: current.kennels.map((k) => ({
					...k,
					area_id: k.area_id === area._id ? '' : k.area_id
				})),
				kennel_blocks: current.kennel_blocks.map((b) => ({
					...b,
					area_ids: b.area_ids ? b.area_ids.filter((id) => id !== area._id) : []
				})),
				playgroups: current.playgroups.map((p) => ({
					...p,
					area_id: p.area_id === area._id ? '' : p.area_id,
					default_outdoor_play_area_id:
						p.default_outdoor_play_area_id === area._id ? '' : p.default_outdoor_play_area_id,
					default_indoor_play_area_id:
						p.default_indoor_play_area_id === area._id ? '' : p.default_indoor_play_area_id
				}))
			}
			setIsDeleteOpen(false)
			saveSelectedFacility(obj)
			setAreaDialog(false)
			selectArea({})
			setCurrent({ ...current, ...obj })
		} catch (e) {
			console.log('big e..', e)
		}
	}

	const deleteKennelType = () => {
		try {
			const obj = {
				kennel_types: current.kennel_types.map((k) => {
					return {
						...k,
						delete: k._id === kennelType._id ? true : false
					}
				}),
				kennels: current.kennels.map((k) => ({
					...k,
					kennel_type_id: k.kennel_type_id === kennelType._id ? '' : k.kennel_type_id
				}))
			}
			setIsDeleteOpen(false)
			saveSelectedFacility(obj)
			setKennelTypeDialog(false)
			selectKennelType({})
			setCurrent({ ...current, ...obj })
		} catch (e) {
			console.log('big e..', e)
		}
	}

	const saveSelectedFacility = (obj) => {
		let updates
		if (obj) {
			updates = obj
		} else {
			updates = {
				...current
			}
		}

		dispatch(updateFacility(selectedFacility._id, updates))
	}

	const clearChanges = () => {
		setCurrent(cloneDeep(selectedFacility))
	}

	const editPlaygroupType = (group) => {
		setPlaygroupTypeDialog(true)
		selectPlaygroupType(group)
	}

	const editKennelBlock = (block) => {
		setKennelBlockDialog(true)
		selectKennelBlock(block)
	}

	const editKennelType = (type) => {
		setKennelTypeDialog(true)
		selectKennelType(type)
	}

	const editArea = (a) => {
		setAreaDialog(true)
		selectArea(a)
	}

	const updateBlock = (key, val) => {
		const updated = {
			...kennelBlock,
			[key]: val
		}

		selectKennelBlock(updated)
	}

	const updateType = (key, val) => {
		const updated = {
			...kennelType,
			[key]: val
		}

		if (updated.width && updated.depth) {
			updated.sq_ft = (updated.width * updated.depth).toFixed(2)
		} else {
			updated.sq_ft = 0
		}

		selectKennelType(updated)
	}

	const saveArea = () => {
		try {
			// setLoading(true)
			let obj
			if (area._id) {
				let newAreas = current.areas.map((t) => {
					if (t._id === area._id) return area
					return t
				})
				obj = {
					...current,
					areas: newAreas
				}
			} else {
				let newArea = { ...area, new: true }
				let newAreas = [...current.areas, newArea]
				obj = {
					areas: newAreas
				}
			}

			saveSelectedFacility(obj)
			setAreaDialog(false)
			selectArea({})
			setCurrent({ ...current, ...obj })
		} catch (e) {
			console.log('big e..', e)
		}
	}

	const saveKennelType = () => {
		try {
			// setLoading(true)
			let obj
			if (kennelType._id) {
				let newTypes = current.kennel_types.map((t) => {
					if (t._id === kennelType._id) return kennelType
					return t
				})
				obj = {
					...current,
					kennel_types: newTypes
				}
			} else {
				let newKenType = { ...kennelType, new: true }
				let newTypes = [...current.kennel_types, newKenType]
				obj = {
					kennel_types: newTypes
				}
			}

			saveSelectedFacility(obj)
			setKennelTypeDialog(false)
			selectKennelType({})
			setCurrent({ ...current, ...obj })
		} catch (e) {
			console.log('big e..', e)
		}
	}

	const saveKennelBlock = () => {
		try {
			// setLoading(true)
			let obj
			if (kennelBlock._id) {
				let newTypes = current.kennel_blocks.map((t) => {
					if (t._id === kennelBlock._id) return kennelBlock
					return t
				})
				obj = {
					...current,
					kennel_blocks: newTypes
				}
			} else {
				let newKennelBlock = { ...kennelBlock, new: true }
				let newTypes = [...current.kennel_blocks, newKennelBlock]
				obj = {
					kennel_blocks: newTypes
				}
			}

			saveSelectedFacility(obj)
			setKennelBlockDialog(false)
			selectKennelBlock({})
			setCurrent({ ...current, ...obj })
		} catch (e) {
			console.log('big e..', e)
		}
	}

	const savePlaygroupType = () => {
		try {
			// setLoading(true)
			let obj
			if (playgroupType._id) {
				let newTypes = current.playgroup_types.map((t) => {
					if (t._id === playgroupType._id) return playgroupType
					return t
				})
				obj = {
					...current,
					playgroup_types: newTypes
				}
			} else {
				let newPlaygroupType = { ...playgroupType, new: true }
				let newTypes = [...current.playgroup_types, newPlaygroupType]
				obj = {
					playgroup_types: newTypes
				}
			}

			saveSelectedFacility(obj)
			setPlaygroupTypeDialog(false)
			selectPlaygroupType({})
			setCurrent({ ...current, ...obj })
		} catch (e) {
			console.log('big e..', e)
		}
	}

	const updateGroup = (key, val) => {
		let group = {
			...playgroupType,
			[key]: val
		}
		selectPlaygroupType(group)
	}

	const updateArea = (key, val) => {
		let update = {
			...area,
			[key]: val
		}
		selectArea(update)
	}

	return (
		<div>
			{current ? (
				<Container className={classes.root} maxWidth="auto">
					<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
						Pet Care Setup
					</Typography>
					<AreasTable data={current?.areas || []} editArea={editArea} />
					<KennelBlocksTable
						data={
							current?.kennel_blocks?.map((block) => {
								let ids = block.area_ids || []
								let mapped = ids
									.map((id) => current.areas.find((a) => a._id === id))
									.filter((a) => !!a)
									.map((a) => a.name)
									.join(', ')
								return {
									...block,
									mapped_areas: mapped
								}
							}) || []
						}
						areas={current?.areas || []}
						kennels={current?.kennels || []}
						editKennelBlock={editKennelBlock}
					/>
					<KennelTypesTable
						data={current?.kennel_types || []}
						areas={current?.areas || []}
						kennels={current?.kennels || []}
						editKennelType={editKennelType}
					/>
					<PlaygroupTypesTable
						data={
							current?.playgroup_types?.map((type) => ({
								...type,
								best_fit_sizes_mapped: type?.best_fit_sizes?.join(', ') || ''
							})) || []
						}
						editPlaygroupType={editPlaygroupType}
					/>
				</Container>
			) : null}
			{loading ? <LoadingOverlay /> : null}
			<PlaygroupTypeDialog
				isShown={playgroupTypeDialog}
				updateGroup={updateGroup}
				save={savePlaygroupType}
				setIsShown={() => {
					setPlaygroupTypeDialog(false)
					selectPlaygroupType({})
				}}
				setDelete={setUpDelete}
				playgroup_types={current?.playgroup_types}
				playgroupType={playgroupType}
			/>
			<KennelBlockDialog
				isShown={kennelBlockDialog}
				updateBlock={updateBlock}
				save={saveKennelBlock}
				setIsShown={() => {
					setKennelBlockDialog(false)
					selectKennelBlock({})
				}}
				kennels={current?.kennels || []}
				areas={current?.areas || []}
				setDelete={setUpDelete}
				kennelBlock={kennelBlock}
			/>
			<KennelTypeDialog
				isShown={kennelTypeDialog}
				updateType={updateType}
				save={saveKennelType}
				setIsShown={() => {
					setKennelTypeDialog(false)
					selectKennelType({})
				}}
				kennels={current?.kennels || []}
				areas={current?.areas || []}
				setDelete={setUpDelete}
				kennelType={kennelType}
			/>
			<AreaDialog
				isShown={areaDialog}
				updateArea={updateArea}
				save={saveArea}
				setIsShown={() => {
					setAreaDialog(false)
					selectArea({})
				}}
				setDelete={setUpDelete}
				area={area}
			/>
			<DeleteConfirmation
				isShown={isDeleteOpen}
				setIsShown={setIsDeleteOpen}
				onConfirmDelete={onConfirmDelete}
				isDeleteLoading={false}
				title={`Delete ${deleteText}`}
				body={`Are you sure you want to delete this ${deleteText}? This action cannot be done.`}
			/>
		</div>
	)
}

export default PetCareSetup
